import { render, staticRenderFns } from "./CoreTableIconButton.vue?vue&type=template&id=a6e8d036&scoped=true&"
import script from "./CoreTableIconButton.vue?vue&type=script&lang=ts&"
export * from "./CoreTableIconButton.vue?vue&type=script&lang=ts&"
import style0 from "./CoreTableIconButton.vue?vue&type=style&index=0&id=a6e8d036&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6e8d036",
  null
  
)

export default component.exports